
export const formatMasterNumber = (element) => {
    let lastName = '',
        datePosition = 0
    for (let i = 0; i < 5; i++) {
        if (isNaN(element[i])) {
            datePosition++
        }
        if (element[i] === ' ') {
            lastName = lastName + ' '
        } else {
            lastName = isNaN(element[i]) ? lastName + element[i] : lastName + ' '
        }
    }
    lastName = lastName + element.substring(datePosition).trim()
    return lastName.toUpperCase();
}